export enum AnotationMemoType {
  NORMAL = 'normal',
  OCCURENCE = 'occurence',
  RECOVERY = 'recovery'
}

export interface AnotationMemoResponse {
  data: AnotationMemoFileInfo[]
  total: number
  page: number
  per_page: number
  total_pages: number
}
export interface AnotationMemoFileInfo {
  id: number
  building_id: number
  floor_id: number
  floor_name: string
  point_id: string
  annotation_id: string
  point_order: number
  name: string
  s3_path: string
  annotations_type: number
  memo_type: string
  set_annotation_id: number
  created_at: string
  updated_at: string
}

export interface MemoListProps {
  buildingId: string
  folderType: string
  childrenType: string
}

export interface MemoViewModalProps {
  visible: boolean
  memo: AnotationMemoFileInfo | null
  onClose: () => void
}
